import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Injectable, Input, OnDestroy, OnInit, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { DxPopupModule, DxScrollViewModule, DxTemplateModule } from 'devextreme-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { OverlaySideFormService } from './overlay-side-form.service';


@Component({
  selector: 'app-overlay-side-form',
  templateUrl: './overlay-side-form.component.html',
  styleUrls: ['./overlay-side-form.component.css']
})
export class OverlaySideFormComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('dynamicInsertPopUp', { static: false, read: ViewContainerRef }) dynamicInsertPopUp: ViewContainerRef;


  isPanelVisible: boolean = false;
  @Input() Visible: boolean = false;
  @Input() bottomToolbar: boolean
  @Input() panelTitle: string;
  @Input() helpDoc:string;
  @Input() showTitle: boolean = true;
  
  @Output() hidePopUp:EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno

  larghezzaPopup: any;
  altezzaPopup: any;



  private _sidePanelServiceSubject$: Subject<void>;
  fullScreen: boolean=false;
  constructor(private _componentFactoryResolver: ComponentFactoryResolver,
    private _overlaySideFormService: OverlaySideFormService, private cdRef: ChangeDetectorRef,private loader:NgxSpinnerService) {
    this._sidePanelServiceSubject$ = new Subject<void>();

  }
  onShowing(e: any) {
    //
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    e.component.content().classList.add("formEditAna","soggetto-form"); //add class to content
    e.component.content().classList.add("form-content"); //add class to content
    
    console.log('onShowing',e.component.content())
   
  }

  onShown(e){
    console.log('onShown',e.component.content())
  }
  ngAfterViewChecked(): void {
    //$( ".dx-popup-bottom" ).css( "background-color", "#023957" );
    $(".dx-popup-bottom").addClass("bottom-bar");
    this._overlaySideFormService.onPopupWidthChanged().subscribe(
      (x) => {
        this.larghezzaPopup = x;
      }
    );

    this._overlaySideFormService.onPopupHeightChanged().subscribe(
      (x) => {
        this.altezzaPopup = x;
      }
    );

    this.cdRef.detectChanges();
  }


  ngOnInit(): void {




    this.isPanelVisible = false;//this.Visible
    this._overlaySideFormService.contentChangeTitle().subscribe((titolo: string) => this.panelTitle = titolo);
    this._overlaySideFormService.contentChangeHelp().subscribe((help: string) => this.helpDoc = help);
    this._overlaySideFormService.onPanelVibilityChange()
      .pipe(takeUntil(this._sidePanelServiceSubject$))
      .subscribe((visible: boolean) => { this.isPanelVisible = visible });

    this._overlaySideFormService.onContentChange()
      .pipe(takeUntil(this._sidePanelServiceSubject$))
      .subscribe((component: Type<any>) => this._setPanelContent(component));
    this._overlaySideFormService.onPanelVibilityChange()
      .subscribe((stato: boolean) => this.isPanelVisible = stato);


  }



  public popupHiding($e) {
    //this._overlaySideFormService.close();

    this._overlaySideFormService.onPopupWidthChanged().subscribe().unsubscribe();
    this.larghezzaPopup = undefined;

    this._overlaySideFormService.onPopupHeightChanged().subscribe().unsubscribe();
    this.altezzaPopup = undefined;
    
    this.isPanelVisible = false;
    this.Visible = false;

    this.fullScreen = false

    this.close()
  }

  public close(): void {
    //alert("Ho chiusoooooooooo");
    this._overlaySideFormService.close();
    this.isPanelVisible = false;
    this.Visible = false;
    this.dynamicInsertPopUp.clear()
    this.hidePopUp.emit('close')
  }

  private _setPanelContent(component: Type<any>) {
    
    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(component);
    this.loader.show()
    
    setTimeout(() => {
      if (this.dynamicInsertPopUp) this.dynamicInsertPopUp.clear();
      let hInstance = this.dynamicInsertPopUp.createComponent(componentFactory);
      let ngClass='soggetto-form'
      this._overlaySideFormService.sendClass.subscribe(data => {


        if (data) {
  
          ngClass = data; //add class to content
        }
      });
      this._overlaySideFormService.dataToComponent.subscribe(data => {

          
        if (data) {

          hInstance.instance.itemData = data;
          hInstance.instance.ngClass = ngClass
        }

       
    
      });

      this._overlaySideFormService.toolbarComponent.subscribe(setToolbar => {

        if (!setToolbar) {

          this.bottomToolbar = false
        } else {
          this.bottomToolbar = true
        }



      })


      this._overlaySideFormService._hrefComponent = hInstance;
      this.loader.hide()
    }, 100);
  }
  ngOnDestroy() {

    this._sidePanelServiceSubject$.next();
    this._sidePanelServiceSubject$.complete();
    

    this.Visible = false;
    this.isPanelVisible = false;


  }


  onClickChiudiOverlay(evt){

    if(evt)
      this._overlaySideFormService.close();
  }


  Help(e) {
    //
    alert("Si dovrebbe gestire l' <strong>help</strong> della form");
  }

  /*
  onOpzioneCambiata(evt){

    console.log("on opzione cambiata:",evt);

    if(evt["name"]=="height")
      this.altezzaPopup = evt["value"];

    if(evt["name"]=="width")
      this.larghezzaPopup = evt["value"];
  }
  */
  fullscreen(ev){
    this.fullScreen = !this.fullScreen
   }
}
